var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-button',_vm._g(_vm._b({staticClass:"s-circle btn-stats"},'default-button',_vm.button_props,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm._f("nibnut.number")(_vm.count,"0,0"))+" "),(!!_vm.glyph)?_c('open-icon',{attrs:{"glyph":_vm.glyph}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }